import React from "react";
import wretch from "wretch";
import { domain, token, selectedClientId, identity } from "./ServiceConfig";

class LogService extends React.Component {
  // List of Functions
  // getUserEvents
  // getUserEventsMock
  // createEventLog

  // Get User Notifications
  getUserEvents = (fromDate, toDate) => {
    if (!fromDate || !toDate) {
      return Promise.reject("Failed - no parameter(s)");
    }

    const searchParameters =
      (fromDate !== "" ? "FromDate=" + fromDate + "&" : "") +
      (toDate !== "" ? "ToDate=" + toDate + "&" : "");

    return wretch()
      .url(`${domain}/EventLog/GetEventLogs?${searchParameters}`)
      .auth(`Bearer ${token()}`)
      .options({ credentials: "include", mode: "cors" })
      .get()
      .json((res) => {
        return Promise.resolve(res);
      })
      .catch((error) => {
        //alert(error);
      });
  };

  // Get User Notifications - Mock Data
  getUserEventsMock = (memberId, clientId = selectedClientId()) => {
    // TODO: Remove
    const testResults = [
      {
        TripId: 1,
        LegId: 101,
        PickUpLocation: "123 Main Street, Cumming GA 30041",
        DropOffLocation: "245 Hospital Way, Alpharetta GA 30003",
        Date: "6/30/2019",
      },
      {
        TripId: 1,
        LegId: 102,
        PickUpLocation: "245 Hospital Way, Alpharetta GA 30003",
        DropOffLocation: "123 Main Street, Cumming GA 30041",
        Date: "6/30/2019",
      },
      {
        TripId: 2,
        LegId: 101,
        PickUpLocation: "567 S. Main Street, Cumming GA 30041",
        DropOffLocation: "100 Hospital Gown Way, Alpharetta GA 30003",
        Date: "7/4/2019",
      },
      {
        TripId: 2,
        LegId: 202,
        PickUpLocation: "100 Hospital Gown Way, Alpharetta GA 30003",
        DropOffLocation: "555 Murphy Street, Roswell GA 30111",
        Date: "7/4/2019",
      },
      {
        TripId: 2,
        LegId: 203,
        PickUpLocation: "555 Murphy Street, Roswell GA 30111",
        DropOffLocation: "567 S. Main Street, Cumming GA 30041",
        Date: "7/4/2019",
      },
      {
        TripId: 3,
        LegId: 301,
        PickUpLocation: "222 W Main Street, Cumming GA 30041",
        DropOffLocation: "245 Hospital Way, Alpharetta GA 30003",
        Date: "7/31/2019",
      },
    ];

    return testResults;
  };

  createEventLog = (
    userId,
    oIdMember,
    event,
    eventStatus,
    notes,
    clientId = selectedClientId()
  ) => {
    return wretch()
      .url(`${domain}/EventLog/Create`)
      .auth(`Bearer ${token()}`)
      .options({ credentials: "include", mode: "cors" })
      .post({
        UserId: userId,
        ClientId: clientId,
        OIdMember: oIdMember, // **** if there is an OIdMember****
        Event: event, // "Logged In"
        EventStatus: eventStatus, // **** 0 for failed, 1 for success****
        Notes: notes,
      })
      .json((res) => {
        console.log("Response from createEventLog", res);
        return Promise.resolve(res);
      })
      .catch((error) => {
        return Promise.reject("Failed");
      });
  };
}

export default LogService;

export const quickLogEvent = (logTitle, logStatus, logNotes) => {
  const clientId = selectedClientId();
  const userId = identity().userId;

  return wretch()
    .url(`${domain}/EventLog/Create`)
    .auth(`Bearer ${token()}`)
    .options({ credentials: "include", mode: "cors" })
    .post({
      UserId: userId,
      ClientId: clientId,
      OIdMember: "", // **** for quick, do not log OIdMember****
      Event: logTitle, // "Logged In"
      EventStatus: logStatus, // **** 0 for failed, 1 for success****
      Notes: logNotes,
    })
    .json((res) => {
      console.log("Response from quick create eventLog", res);
      return Promise.resolve(res);
    })
    .catch((error) => {
      console.log("token", token());
      console.log("quick create eventLog failed", error);
      return Promise.reject("Failed");
    });
};
